import { styled } from '@mui/material/styles';

const ModalTitleStyle = styled('h3')({
    textAlign: 'center',
    marginTop: '15px',
    marginBottom: '15px',
});

function ModalTitle({ label }) {
    return (
        <ModalTitleStyle>{label}</ModalTitleStyle>
    );
}

export default ModalTitle